<div #container *ngIf="filters" class="d-flex align-items-stretch" style="flex: 1"
     [ngClass]="{'mb-0': modalOptions.fullScreen || isReportMode, 'card': !isReportMode, 'report-view': isReportMode}">
    <ng-container *ngIf="!isReportMode">
        <div class="card-header dropdown">
            <h4 class="card-header-title">
                <app-connection-image [connectionType]="mainConnectionType"></app-connection-image>
                <span *ngIf="chartTitle === 'Gas and heat consumption'">Gas and heat consumption</span>
                <span *ngIf="chartTitle === 'Cooling consumption'">Cooling consumption</span>
                <span *ngIf="chartTitle === 'Heat and cooling consumption'">Heat and cooling consumption</span>
                <span *ngIf="chartTitle === 'Gas, heat and cooling consumption'">Gas, heat and cooling consumption</span>
                <app-tooltip class="ms-2" placement="top" *ngIf="completenessInfo">
                    <span class="notranslate" [style.color]="completenessInfo.color">{{completenessInfo.completeness}}%</span>
                    <div class="tooltipContent">
                        <span class="notranslate">{{ completenessInfo.title }}</span>
                    </div>
                </app-tooltip>
            </h4>
            <app-data-provider-date-range class="ms-2" *ngIf="modalOptions.fullScreen"></app-data-provider-date-range>
            <button *ngIf="!modalOptions.fullScreen" type="button" class="btn" role="button" (click)="openModal()"><i
                    class="bi bi-arrows-angle-expand"></i></button>
            <app-chart-download-button [element]="container" [tableElement]="tableElement"
                                       [connectionTypes]="connectionTypes" [optionalDataTypes]="options.selectedWeatherTypes"></app-chart-download-button>
            <button type="button" class="btn" role="button" (click)="toggleShowAsTable()">
                <i class="bi" [ngClass]="options.showAsTable ? 'bi-bar-chart-line' : 'bi-table'"></i>
            </button>
            <button type="button" class="btn" role="button" data-bs-toggle="dropdown"
                    data-bs-auto-close="outside" aria-expanded="false">
                <i class="bi bi-three-dots-vertical"></i>
            </button>
            <app-widget-options-menu title="Display settings" [anchorBelowTrigger]="modalOptions.fullScreen">
                <div class="dropdown-item">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" [id]="getInputId('showCooling')"
                               [ngModel]="showingCooling" (ngModelChange)="setShowCooling($event)">
                        <label class="form-check-label" [for]="getInputId('showCooling')">Show cooling</label>
                    </div>
                </div>
                <div class="dropdown-item d-flex align-items-center gap-2"
                     [class.text-muted]="!climateNormalizationCanBeRequested">
                    <div class="form-check flex-grow-1">
                        <input class="form-check-input" type="checkbox" [id]="getInputId('gasConsumptionClimate')"
                               [ngModel]="gasConsumptionView !== 'actual'"
                               [disabled]="!climateNormalizationCanBeRequested"
                               (ngModelChange)="setClimateYearCorrected($event)">
                        <label class="form-check-label" [for]="getInputId('gasConsumptionClimate')">Normalize climate year</label>
                    </div>
                    <app-widget-option-info
                            label="Normalize climate year"
                            description="Refine the gas and heat display by normalizing climate-sensitive consumption to the WEii 3.1 reference climate of 2,200 heating degree days. The calculation uses a 16.5 °C base temperature and assumes that 80% of gas and heat consumption is used for space heating. This allows different periods to be compared more fairly. Enable this option only when that assumption is appropriate for the selected buildings. One correction factor is calculated over the completed part of the selected period. Provisional periods continue to show actual consumption and are identified as provisional. Climate year normalization is available in month and year views."
                            [unavailableMessage]="!climateNormalizationCanBeRequested || (gasConsumptionView !== 'actual' && !climateNormalizationAvailable) ? climateNormalizationUnavailableMessage : null">
                    </app-widget-option-info>
                </div>
                <div class="dropdown-item" [class.text-muted]="gasConsumptionView === 'actual'">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" [id]="getInputId('gasConsumptionClimateCompare')"
                               [ngModel]="gasConsumptionView === 'compareClimate'"
                               [disabled]="!climateNormalizationAvailable || gasConsumptionView === 'actual'"
                               (ngModelChange)="setClimateComparison($event)">
                        <label class="form-check-label" [for]="getInputId('gasConsumptionClimateCompare')">Compare with actual consumption</label>
                    </div>
                </div>
                <div class="dropdown-item" *ngIf="groupByEntityId && options.groupByEntityIdPossible && !onlyMetersSelected">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" [id]="getInputId('groupByEntityId')"
                               [ngModel]="options.groupByEntityId" (ngModelChange)="groupByEntityIdChange($event)">
                        <label class="form-check-label" [for]="getInputId('groupByEntityId')">
                            Split by sub meters
                        </label>
                    </div>
                </div>
                <div class="dropdown-item">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" [id]="getInputId('showCompleteness')"
                               [ngModel]="options.showCompleteness" (ngModelChange)="showCompletenessChange($event)">
                        <label class="form-check-label" [for]="getInputId('showCompleteness')">
                            Completeness
                        </label>
                    </div>
                </div>
                <div class="dropdown-item" [class.text-muted]="gasConsumptionView === 'compareClimate'">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" [id]="getInputId('checkboxCompareGas')"
                               [ngModel]="options.compare.enabled" [disabled]="gasConsumptionView === 'compareClimate'"
                               (ngModelChange)="compareChange($event)">
                        <div class="row">
                            <label class="form-check-label col-auto" [for]="getInputId('checkboxCompareGas')">Compare with</label>
                            <app-select class="col px-0 notranslate" [ngModel]="options.compare"
                                        (ngModelChange)="comparedYearChange($event)" [options]="compareYearOptions" [small]="true"
                                        [disabled]="gasConsumptionView === 'compareClimate'"
                                        [formatter]="compareFormatter" [equalsFunction]="compareEquals"></app-select>
                        </div>
                    </div>
                </div>
                <div class="dropdown-item">
                    <ng-container *ngIf="isPortfolio else locationDashboardPower">
                        <ng-container *ngTemplateOutlet="portfolioDashboardPower"></ng-container>
                    </ng-container>
                </div>
                <div class="dropdown-item" *ngIf="AppContext.isAdminOrIntermediary()">
                    <div class="form-check ">
                        <input class="form-check-input" type="checkbox" [id]="getInputId('checkboxShowIncidents')"
                               [ngModel]="options.showIncidents" (ngModelChange)="showIncidentsChange($event)">
                        <div class="row">
                            <label class="form-check-label col-auto"
                                   [for]="getInputId('checkboxShowIncidents')">Alerts</label>
                            <app-simple-multi-select *ngIf="options.showIncidents" class="col px-0" [ngModel]="options.selectedIncidents"
                                                     (ngModelChange)="incidentsChange($event)"
                                                     [options]="incidentOptions" [equalsFunction]="compareIncidents">
                            </app-simple-multi-select>
                        </div>
                    </div>
                </div>
                <app-widget-options-section title="Weather">
                <div *ngFor="let weatherType of appContext.weatherTypes" class="dropdown-item">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" [id]="getWeatherInputId(weatherType)"
                               [checked]="isDataTypeSelected(weatherType)" (click)="toggleWeather(weatherType)">
                        <label class="form-check-label" [for]="getWeatherInputId(weatherType)">
                            {{ appContext.measurementName(weatherType, false) }}
                        </label>
                    </div>
                </div>
                </app-widget-options-section>
            </app-widget-options-menu>
            <button *ngIf="modalOptions.fullScreen" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
    </ng-container>
    <div class="chart-body pt-0 mh-100" [ngClass]="{'p-0': options.showAsTable, 'card-body': !isReportMode}">
        <ng-container *ngIf="isReportMode else notInReport">
            <ng-container [ngTemplateOutlet]="chart"></ng-container>
            <app-chart-table class="w-100" [dataProvider]="chartDataProvider"
                             [compare]="options.compare" [displayTimeRange]="displayTimeRange"
                             [comparisonLabels]="gasConsumptionView === 'compareClimate' ? climateComparisonTableLabels : null"
                             [unitOverride]="showConsumptionPerDegreeDay ? measurementUnit() : null"></app-chart-table>
        </ng-container>
        <ng-template #notInReport>
            <app-chart-table class="w-100" [ngClass]="{'d-none': !options.showAsTable}"
                             [dataProvider]="chartDataProvider" [compare]="options.compare"
                             [comparisonLabels]="gasConsumptionView === 'compareClimate' ? climateComparisonTableLabels : null"
                             (tableElement)="tableElement = $event" [displayTimeRange]="displayTimeRange"
                             [unitOverride]="showConsumptionPerDegreeDay ? measurementUnit() : null"></app-chart-table>
            <ng-container *ngIf="!options.showAsTable">
                <ng-container [ngTemplateOutlet]="chart"></ng-container>
            </ng-container>
        </ng-template>
    </div>
</div>

<ng-template #chart>
    <app-bar-chart class="chart h-100 w-100" [y1AxisMeasurement]="measurementUnit()"
                   style="flex: 1" [y2AxisMeasurement]="y2AxisTitle" [powerAxisMeasurement]="powerAxisTitle"
                   [dataProvider]="chartDataProvider" [showNormalAxis]="true" [stacked]="showingCooling ? true : undefined" [showCompleteness]="options.showCompleteness"
                   [selectedWeatherTypes]="options.selectedWeatherTypes" [weatherTypes]="appContext.weatherTypes"
                   [fullScreen]="modalOptions.fullScreen" [skipPaddingX]="modalOptions.fullScreen || isReportMode"
                   [animationDuration]="isReportMode ? 0 : 1000" [directiveView]="this" [otherPlugins]="plugins"
                   [customOnClick]="isReportMode ? false : undefined">
    </app-bar-chart>
</ng-template>

<ng-template #portfolioDashboardPower>
    <div class="form-check">
        <ng-container *ngIf="selectedConnections.length !== 1 else enabled">
            <input class="form-check-input" type="checkbox" [id]="getInputId('checkboxShowPower')" disabled>
        </ng-container>
        <ng-template #enabled>
            <input class="form-check-input" type="checkbox" [id]="getInputId('checkboxShowPower')"
                   [ngModel]="options.showPower" (ngModelChange)="showPowerChange($event)">
        </ng-template>
        <label class="form-check-label" [for]="getInputId('checkboxShowPower')">
            <span class="me-2">Maximum power</span>
            <ng-container *ngIf="selectedConnections.length !== 1 else oneConnectionSelected">
                <i class="bi bi-exclamation-triangle-fill" data-bs-toggle="tooltip" data-bs-placement="top"
                   title="Maximum power can only be shown per EAN"></i>
            </ng-container>
            <ng-template #oneConnectionSelected>
                <i *ngIf="!hasPower() else contractedCapacityEl" class="bi bi-exclamation-triangle-fill" data-bs-toggle="tooltip"
                   data-bs-placement="top" title="Power data is unavailable for this connection"></i>
                <ng-template #contractedCapacityEl>
                    <i *ngIf="!contractedCapacity(mainConnectionType)" class="bi bi-exclamation-triangle-fill" data-bs-toggle="tooltip"
                       data-bs-placement="top" title="Contracted power is unknown for this connection"></i>
                </ng-template>
            </ng-template>
        </label>
    </div>
</ng-template>
<ng-template #locationDashboardPower>
    <ng-container *ngIf="{ val: getSelectedEans()} as eanCodes">
        <div class="form-check">
            <ng-container *ngIf="eanCodes.val.length === 0 else enabled">
                <input class="form-check-input" type="checkbox" [id]="getInputId('checkboxShowPower')" disabled>
            </ng-container>
            <ng-template #enabled>
                <input class="form-check-input" type="checkbox" [id]="getInputId('checkboxShowPower')"
                       [ngModel]="options.showPower && showPowerForEan(mainConnectionType)"
                       (ngModelChange)="showPowerChange($event)">
            </ng-template>
            <div class="row">
                <label class="form-check-label col-auto" [for]="getInputId('checkboxShowPower')">Maximum power</label>
                <ng-container *ngIf="eanCodes.val.length > 1 else noConnections">
                    <app-select class="col px-0 notranslate" [ngModel]="options.showPowerForEan" (ngModelChange)="showPowerForEanChange($event)"
                                [options]="eanCodes.val" [small]="true"></app-select>
                </ng-container>
                <ng-template #noConnections>
                    <i *ngIf="eanCodes.val.length === 0" class="col-auto bi bi-exclamation-triangle-fill"
                       data-bs-toggle="tooltip" data-bs-placement="top" title="No connections found within selection"></i>
                </ng-template>
                <i *ngIf="options.showPower && !hasPower()" class="col-auto ps-0 bi bi-exclamation-triangle-fill"
                   data-bs-toggle="tooltip" data-bs-placement="top"
                   title="Power data is unavailable for this connection"></i>
            </div>
        </div>
    </ng-container>
</ng-template>
